import React, { useEffect } from "react";
import "../assets/css/App.css";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import LateralMenu from "../componentes/LateralMenu";
import SearchBar from "../componentes/SearchBar";

//FUNCION CERRAR MENU
import { esconderMenuLateral } from "../assets/js/menuLateral";

import FilterableOportunityTable from "../componentes/oportunidad/FilterableOportunityTable";

function App() {
  useEffect(() => {
    document.title = "Oportunidades | UpSales";
    return () => {};
  }, []);

  return (
    <Container className="pos-r" fluid={true}>
      <div
        id="ic-menu-out"
        onClick={() => esconderMenuLateral()}
        className="bg-arrow d-center arrow-menu-out d-none orange-up"
      >
        <p>&gt;</p>
      </div>
      <Row>
        <LateralMenu></LateralMenu>

        <Col className="bg-blue-light">
          <Row className="nav-style brd-b-blue bg-white justify-content-center">
            <Col xs={11} className="align-self-center p-0">
              <SearchBar />
            </Col>
          </Row>

          <Row className="justify-content-center bg-blue-light">
            <Col xs={12} className="pt-4 pb-3">
              <Row>
                <a className="pl-3 light-grey" href="#">
                  {" "}
                  Oportunidades
                </a>
              </Row>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <FilterableOportunityTable></FilterableOportunityTable>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default App;
